import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {
  cdnUrl,
  marketingMobileCuttoff,
  white,
} from '@css/constants'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'

export const MissionSectionContainer = styled('div')(css`
  flex-direction: row;
  display: flex;
  background-image: ${cdnUrl('img/image-mission-runner-desktop.jpg')};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  height: 760px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    background-image: ${cdnUrl('img/image-mission-runner-mobile.jpg')};
    height: auto;
  }
`)

export const MissionSectionEmptyCol = styled('div')(css`
  flex-direction: column;
  display: flex;
  justify-content: center;
`)

export const MissionSectionCol = styled('div')(css`
  flex-direction: column;
  display: flex;
  justify-content: center;
  padding-left: 100px;
  max-width: 450px;

  @media(max-width: 1030px) {
    max-width: 435px;
  }
  
  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    margin: 60px 0;
  }
`)

export const MissionSectionTitle = styled('div')(css`
  font-size: 45px;
  ${FontNormal(600)};
  color: ${white};
  padding-bottom: 24px;
  
  @media(max-width: ${marketingMobileCuttoff}) {
    font-size: 24px;
  }
`)

export const MissionSectionText = styled('div')(css`
  ${fontSize(20)};
  ${FontNormal(500)};
  color: ${white};
  
  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(16)};
  }
`)
